import * as GenerationModule from "./src/generation/index.js";
import { createAssistantBridge } from "./src/ui/assistant/bridge.js";
import { bindAgentModules } from "./src/agent/index.js";
import * as ProjectModule from "./src/project/index.js";
import * as AppStateModule from "./src/frontend/app-state.js";
import * as WorkspaceUiModule from "./src/frontend/workspace-controller.js";
import * as ControlSpecControllerModule from "./src/control-spec/controller.js";
import { mountAssistantApp } from "./src/ui/assistant/app.js";
import {
    applyAssistantChatConfig,
    readAssistantChatConfig,
    writeAssistantChatConfig
} from "./src/ui/assistant/config.js";
import {
    answerPlanQuestion as answerPlanQuestionModule,
    buildAssistantSettingsSummary,
    presentCurrentPlanQuestion as presentCurrentPlanQuestionModule,
    refreshTaskHistoryPanel as refreshTaskHistoryPanelModule,
    requestThreadTitleFromAi as requestThreadTitleFromAiModule,
    setQuestionDraftInput as setQuestionDraftInputModule,
    submitChatComposer as submitChatComposerModule,
    submitPlanAnswerFromInput as submitPlanAnswerFromInputModule,
    toggleTaskHistoryPanel as toggleTaskHistoryPanelModule
} from "./src/ui/assistant/runtime.js";
import { buildAssistantViewModel } from "./src/ui/assistant/view-model.js";
import { getFrontendDomRefs as getModuleFrontendDomRefs } from "./src/frontend/dom-refs.js";
import { createTemplateGallery } from "./src/frontend/template-gallery.js";
import {
    buildControlSpecViewModel,
    serializeIoTableCsv,
    hasBlockingControlSpecFindings,
    getBlockingControlSpecFindings,
    mergeControlSpecFindings,
    formatControlSpecFindingSource,
    formatControlSpecFindingTarget,
    buildControlSpecFindingTargetActions,
    buildControlSpecFindingsMeta,
    buildEmptyControlSpecFindingsMessage,
    buildControlSpecFindingDisplayModel,
    buildControlSpecFindingRowModel,
    buildControlSpecOutputSections,
    buildControlSpecIoRowModel,
    formatIoReferencedBy,
    formatControlSpecCommands,
    formatControlSpecConditions,
    formatControlSpecConditionStepExpression,
    formatControlSpecConditionBranches,
    getActuatorTypeLabel,
    getMotorControlTypeLabel,
    getPneumaticValveModeLabel,
    buildActuatorTypeCatalogFormInput,
    buildActuatorTypeCatalogDraft,
    validateActuatorTypeCatalogDraft,
    buildSavedActuatorTypeCatalogState,
    buildDeleteActuatorTypeCatalogState,
    buildActuatorTypeCatalogFormState,
    buildActuatorTypeCatalogEditorState,
    buildActuatorTypeReferenceSummary,
    buildActuatorTypeOptionsState,
    buildFlowActionSelectionState,
    buildFlowMotionEditorState,
    buildFlowMotionEditorMarkup,
    buildFlowMotionNameState,
    buildFlowMotionNameAppliedState,
    buildFlowMotionActionState,
    buildFlowMotionActionAppliedState,
    buildFlowMotionActuatorChangeState,
    buildFlowMotionActuatorAppliedState,
    buildFlowMotionSyncState,
    buildFlowMotionSavedState,
    buildFlowMotionAppliedDataState,
    bindFlowMotionEditorEvents,
    mountFlowMotionEditor,
    mountFlowConditionEditor,
    buildFlowConditionEditorState,
    buildFlowConditionRenderState,
    buildFlowConditionEditorRenderState,
    buildFlowConditionEditorPanelState,
    bindFlowConditionEditorEvents,
    buildFlowConditionEditorMarkup,
    buildFlowConditionSectionMarkup,
    buildFlowConditionModeChangeState,
    buildFlowConditionModeAppliedState,
    buildFlowConditionTextState,
    buildFlowConditionTextAppliedState,
    buildFlowConditionKindChangeState,
    buildFlowConditionKindAppliedState,
    buildFlowConditionOperatorChangeState,
    buildFlowConditionOperatorAppliedState,
    buildFlowConditionExpressionState,
    buildFlowConditionExpressionAppliedState,
    buildFlowConditionFlagSelectState,
    buildFlowConditionFlagAppliedState,
    buildFlowConditionBranchLabelState,
    buildFlowConditionBranchLabelAppliedState,
    buildFlowConditionTimeoutSecState,
    buildFlowConditionTimeoutSecAppliedState,
    buildFlowConditionTimeoutLabelState,
    buildFlowConditionTimeoutLabelAppliedState,
    buildFlowConditionRowInputState,
    buildFlowConditionRowInputAppliedState,
    buildFlowConditionRowFlagSelectState,
    buildFlowConditionRowFlagSelectAppliedState,
    buildFlowConditionRowRemoveState,
    buildFlowConditionRowRemoveAppliedState,
    buildFlowConditionAddRowState,
    buildFlowConditionAddRowAppliedState,
    buildFlowConditionSyncState,
    buildFlowStructuredConditionApplyState,
    buildFlowStructuredConditionAppliedState,
    buildFlowStructuredConditionAppliedDataState,
    buildFlowStructuredConditionCommitState,
    buildFlowStructuredConditionCommittedDataState,
    buildFlowConditionSavedState,
    buildFlowSignalOutputSyncState,
    buildFlowSignalOutputEditorState,
    buildFlowSignalOutputEditorMarkup,
    buildFlowSignalOutputScopeChangeState,
    buildFlowSignalOutputScopeAppliedState,
    buildFlowSignalOutputNameChangeState,
    buildFlowSignalOutputNameAppliedState,
    buildFlowSignalOutputLabelState,
    buildFlowSignalOutputLabelAppliedState,
    buildFlowSignalOutputInternalFlagSelectState,
    buildFlowSignalOutputInternalFlagAppliedState,
    buildFlowSignalOutputActionChangeState,
    buildFlowSignalOutputActionAppliedState,
    buildFlowSignalOutputSavedState,
    buildFlowSignalOutputAppliedDataState,
    bindFlowSignalOutputEditorEvents,
    mountFlowSignalOutputEditor,
    buildFlowSubprocessEditorState,
    buildFlowSubprocessEditorMarkup,
    buildFlowSubprocessSelectionState,
    buildFlowSubprocessNameState,
    buildFlowSubprocessDurationState,
    buildFlowSubprocessSyncState,
    bindFlowSubprocessEditorEvents,
    mountFlowSubprocessEditor,
    buildFlowErrorEditorState,
    buildFlowErrorEditorMarkup,
    buildFlowErrorCodeState,
    buildFlowErrorMessageState,
    buildFlowErrorSyncState,
    bindFlowErrorEditorEvents,
    mountFlowErrorEditor,
    buildFlowButtonEditorState,
    buildFlowButtonEditorMarkup,
    buildFlowButtonModeChangeState,
    buildFlowButtonLabelState,
    buildFlowButtonSignalState,
    buildFlowButtonBranchLabelState,
    buildFlowButtonSyncState,
    bindFlowButtonEditorEvents,
    mountFlowButtonEditor,
    buildFlowEndEditorState,
    buildFlowEndEditorMarkup,
    buildFlowEndResultChangeState,
    buildFlowEndLabelState,
    buildFlowEndSyncState,
    bindFlowEndEditorEvents,
    mountFlowEndEditor,
    buildMotorControlTypeFieldState,
    buildPneumaticValveModeFieldState,
    buildActuatorControlMethodFieldState,
    buildActuatorTypeSelectRefreshState,
    buildControlSpecActuatorListState,
    buildControlSpecActuatorRowModel,
    buildControlSpecSignalListState,
    buildControlSpecSignalRowModel,
    buildControlSpecSignalCategoryListState,
    buildControlSpecSignalCategoryRowModel,
    buildControlSpecFlowSignalCandidateOptionsState,
    buildControlSpecFlowSignalCandidateFormState,
    buildControlSpecFlowSignalCandidateApplyState,
    normalizeSignalDataType,
    toSignalDraftId,
    makeUniqueSignalDraftId,
    findExistingSignalByName,
    buildNextSignalAddress,
    buildControlSpecFlowConditionCandidates,
    buildControlSpecFlowSignalOutputCandidate,
    appendUniqueControlSpecFlowCandidates,
    buildControlSpecSignalFormInput,
    buildControlSpecSignalDraft,
    validateControlSpecSignalDraft,
    buildSavedControlSpecSignals,
    buildDeleteControlSpecSignalState,
    findControlSpecSignalReferenceInActuators,
    buildLoadedControlSpecSignalFormState,
    buildResetControlSpecSignalFormState,
    buildControlSpecSignalCategoryFormInput,
    buildSignalCategoryOptionsState,
    buildLoadedSignalCategoryFormState,
    buildResetSignalCategoryFormState,
    buildControlSpecSignalCategoryDraft,
    validateControlSpecSignalCategoryDraft,
    buildSavedControlSpecSignalCategories,
    buildDeleteControlSpecSignalCategoryState,
    buildControlSpecActuatorFormInput,
    buildControlSpecActuatorDraft,
    validateControlSpecActuatorDraft,
    buildSavedControlSpecActuators,
    buildDeleteControlSpecActuatorState,
    findControlSpecActuatorReferenceInFlow,
    buildLoadedControlSpecActuatorFormState,
    buildResetControlSpecActuatorFormState,
    buildResetControlSpecActuatorActionState,
    buildDeleteControlSpecActionState,
    buildAddedControlSpecActionState,
    createEmptyControlSpecActuatorAction,
    getNextControlSpecActionPresetName,
    buildControlSpecActionDetailFormInput,
    buildControlSpecActionDetailDraft,
    validateControlSpecActionDetailDraft,
    buildSavedControlSpecActionDetailState,
    buildLoadedControlSpecActionDetailState,
    buildControlSpecActionSignalOptionsState,
    buildControlSpecActionListState,
    buildControlSpecActionListRowModel,
    buildControlSpecActionRowModel,
    buildControlSpecConditionRowModel,
    buildControlSpecErrorStepRowModel,
    buildControlSpecTimeoutFindingRowModel,
    formatControlSpecBlockingFindings,
    localizeControlSpecFindingMessage,
    normalizeAxisActuatorType,
    normalizeMotorControlType,
    normalizePneumaticValveMode,
    normalizeActuatorControlMethod,
    normalizeActuatorTypeCatalogEntry,
    normalizeControlSpecText,
    buildControlSpecSlug,
    normalizePlcopenActionMeta,
    normalizeActionCommand,
    normalizeActionParameters,
    normalizeActionStatus,
    createDefaultPlcopenPins,
    normalizeSignalCategoryEntry,
    getDefaultActuatorActionTemplates,
    createDefaultActuatorActions,
    mergeActuatorActionsWithDefaults
} from "./src/frontend/control-spec-helper.js";
import * as FlowNodeHtmlModule from "./src/flow/flow-node-html.js";
import * as FlowControllerModule from "./src/flow/flow-controller.js";
import * as SubprocessPreviewModule from "./src/flow/subprocess-preview.js";
import * as AssistantClassifyModule from "./src/agent/classify.js";
import { createDrawflowAdapter } from "./src/flow/drawflow-adapter.js";
import * as UnitsModule from "./src/timing/units.js";
import * as MotionProfileModule from "./src/timing/motion-profile.js";
import * as TimingStateModule from "./src/timing/timing-state.js";
import * as TimingGridControllerModule from "./src/timing/timing-grid-controller.js";
import { createSpeedChartAdapter } from "./src/timing/speed-chart-adapter.js";
import { bindProjectsBootstrapRuntime } from "./src/frontend/projects-bootstrap.js";
import { getClerkAccessToken, initializeClerk } from "./src/api-client/clerk-browser.js";
import {
    applyAccountSettingsDefaultsToProject as applyAccountSettingsDefaultsToProjectModule,
    buildAccountSettingsJsonFromProject as buildAccountSettingsJsonFromProjectModule,
    getAccountSettings,
    loadAccountSettingsFromCloud as loadAccountSettingsFromCloudModule,
    saveAccountSettingsToCloud as saveAccountSettingsToCloudModule,
    updateAccountSettings
} from "./src/api-client/account-settings-api.js";
import {
    bindAgentSessionApiRuntime,
    bindAssistantTitleApiRuntime,
    bindGenerationApiRuntime,
    bindRawFlowIndexRuntime
} from "./src/frontend/api-bootstrap.js";
import { createSkillsUiController } from "./src/frontend/skills-ui.js";
import {
    buildChatDialectSyncState,
    buildDuplicatedPlcProfile,
    buildInstructionWithPlcProfile,
    buildPlcProfileBaseLabel,
    buildPlcProfileEditorHints,
    buildPlcProfileOptions,
    buildProjectPlcProfilesState,
    cancelPlcProfileEdit as cancelPlcProfileEditModule,
    deleteActivePlcProfile as deleteActivePlcProfileModule,
    duplicateActivePlcProfile as duplicateActivePlcProfileModule,
    editActivePlcProfile as editActivePlcProfileModule,
    ensureProjectPlcProfiles as ensureProjectPlcProfilesModule,
    focusPlcProfileField as focusPlcProfileFieldModule,
    getActivePlcProfile as getActivePlcProfileModule,
    buildPlcProfileSaveCandidate,
    buildRemainingPlcProfilesAfterDelete,
    buildSavedPlcProfiles,
    buildOpenPlcProfileEditorState,
    buildClosedPlcProfileEditorState,
    buildPlcProfileFieldFocusState,
    buildPlcProfileEditActionState,
    normalizePlcProfileSelectionValue,
    buildPlcProfileRuleLines,
    buildPlcProfileSummary,
    collectPlcProfileConsistencyHints,
    collectActivePlcProfileWarnings,
    createDefaultUserPlcProfiles,
    formatPlcProfileFieldLabel,
    getDialectMeta,
    resolveDialectMeta as resolveDialectMetaModule,
    normalizePlcProfile,
    resolveActivePlcProfile,
    resolvePlcProfile,
    savePlcProfileEdit as savePlcProfileEditModule,
    syncChatDialectFromProfile as syncChatDialectFromProfileModule,
    updatePlcProfileDraft as updatePlcProfileDraftModule,
    updatePlcProfileDraftValue,
    validatePlcProfileForSave
} from "./src/plc-profile/builtins.js";
function createAssistantBootstrapBridge() {
    const getAssistantViewModel = () => {
        const activeThread = ensureActiveChatThread();
        const activeProfile = getActivePlcProfile();
        const editorDraft = state.chat.plcProfileEditor?.draft || null;
        return buildAssistantViewModel({
            chat: {
                ...state.chat,
                dialect: activeProfile.vendorTarget || state.chat.dialect,
                plcProfileId: activeProfile.id,
                plcProfileOptions: getPlcProfileOptions(),
                canEditPlcProfile: Boolean(activeProfile.editable),
                activePlcProfileKind: activeProfile.editable ? "user" : "built-in",
                activePlcProfileBaseLabel: buildPlcProfileBaseLabel(activeProfile),
                activePlcProfileSummary: buildPlcProfileSummary(activeProfile),
                activePlcProfileMarkdown: activeProfile.promptRules || "",
                activePlcProfileRules: buildPlcProfileRuleLines(activeProfile),
                activePlcProfileWarnings: collectActivePlcProfileWarnings(activeProfile),
                plcProfileEditorHints: editorDraft ? buildPlcProfileEditorHints(editorDraft) : [],
                threadTitle: activeThread.label || "新規チャット"
            },
            historyItems: getAssistantTaskHistoryItems(),
            blocks: getAssistantMessageBlocks()
        });
    };
    return createAssistantBridge({
        state,
        subscribe(listener) {
            assistantUiSubscribers.add(listener);
            return () => assistantUiSubscribers.delete(listener);
        },
        getViewModel: getAssistantViewModel,
        setVisibility: setChatVisibility,
        toggleSettings: toggleChatSettings,
        startNewChat: startNewChatThread,
        toggleTaskHistory: toggleTaskHistoryPanel,
        refreshTaskHistory: refreshTaskHistoryPanel,
        resumeHistory: resumeAgentSessionFromHistory,
        setMode: setChatModeValue,
        setDialect: setChatDialectValue,
        duplicatePlcProfile: duplicateActivePlcProfile,
        editPlcProfile: editActivePlcProfile,
        deletePlcProfile: deleteActivePlcProfile,
        focusPlcProfileField,
        cancelPlcProfileEdit,
        savePlcProfileEdit,
        updatePlcProfileDraft,
        submitComposer: submitChatComposer,
        runAction: runChatAction,
        handleAction: handleAssistantAction,
        clearHistory: clearChatHistory,
        copyResult: copyChatResult,
        exportFlowContext: () => getPreferredGenerationApi().exportFlowContext(),
        exportGenerationIr: () => getPreferredGenerationApi().exportGenerationIr(),
        setQuestionDraftInput,
        submitQuestionDraft: async (questionId, value) => {
            if (state.chat.busy) return false;
            state.chat.busy = true;
            renderChatUi();
            try {
                await answerPlanQuestion(questionId, value, value);
                return true;
            } finally {
                state.chat.busy = false;
                renderChatUi();
            }
        },
        toggleWorklog: toggleWorklogGroup,
        navigateToSkills: () => {
            setActiveView("skills");
        }
    });
}

function exposeBootstrapWindowApis() {
    // Compatibility / module-first fallback exports used by the legacy HTML mirror.
    if (typeof window.__appStateGenId !== "function") {
        window.__appStateGenId = AppStateModule.createIdGenerator();
    }
    window.__appState = state;
    window.__createTemplateGallery = createTemplateGallery;
    window.__createDrawflowAdapter = createDrawflowAdapter;

    // Timing APIs (Phase 4)
    window.__createSpeedChartAdapter = createSpeedChartAdapter;

    // Runtime UI bridge consumed by the Vue assistant app.
    window.__assistantBridge = createAssistantBootstrapBridge();
}

function mountAssistantBootstrapApp() {
    // Debug-only handle for the mounted Vue app. Normal runtime communication
    // should go through window.__assistantBridge.
    window.__assistantVueApp = mountAssistantApp(
        document.getElementById("assistantApp"),
        window.__assistantBridge
    );
}

function bindAgentModulesBootstrap() {
    bindAgentModules(window, {
        buildLocalFlowDraft,
        findDraftMotion,
        findDraftMotionById,
        findDraftConditionNode,
        hasDraftConnection,
        extractAxisNameFromText,
        detectOffBranchFromText,
        detectAfterMotionFromText,
        extractTimeoutSecFromText,
        extractErrorCodeFromText,
        requestRemoteAgentSessionCreate,
        requestRemoteAgentSessionAnswer,
        requestAgentFlowDraft,
        cloneJsonValue,
        syncAgentJobState,
        applyAnswersToDraft,
        pushPlanActivity,
        genId,
        getNodeData,
        getNodeTypeFromData,
        resolveMotionByNodeId: (nodeId) => {
            const motionId = state.nodeIdToMotionId?.[String(nodeId)];
            return motionId ? findMotion(motionId) : null;
        }
    });
    console.info("[phase4] agent modules bound via src/agent/index.js");
}

exposeBootstrapWindowApis();
if (typeof import.meta.env?.VITE_CLERK_PUBLISHABLE_KEY === "string" && import.meta.env.VITE_CLERK_PUBLISHABLE_KEY.trim()) {
    void initializeClerk().catch(() => {});
}
mountAssistantBootstrapApp();
bindAgentModulesBootstrap();
bindGenerationApiRuntime({
    bindGenerationClient: window.__bindGenerationClient,
    getAccessToken: getClerkAccessToken,
    info: (...args) => console.info(...args),
    warn: (...args) => console.warn(...args)
});
bindRawFlowIndexRuntime({
    bindRawFlowIndexBuilder: window.__bindRawFlowIndexBuilder,
    warn: (...args) => console.warn(...args)
});
bindAgentSessionApiRuntime({
    bindAgentSessionClient: window.__bindAgentSessionClient,
    getAccessToken: getClerkAccessToken,
    restoreAgentSessionFromStorage: () => window.restoreAgentSessionFromStorage?.(),
    info: (...args) => console.info(...args),
    warn: (...args) => console.warn(...args)
});
bindAssistantTitleApiRuntime({
    bindAssistantTitleClient: window.__bindAssistantTitleClient,
    info: (...args) => console.info(...args),
    warn: (...args) => console.warn(...args)
});

function runPhase3GenerationFacadeSwap() {
    const expected = window.__GENERATION_INDEX_EXPECTED_EXPORTS || [];
    const actual = new Set(Object.keys(GenerationModule));
    const missing = expected.filter(name => !actual.has(name));
    const unexpected = [...actual].filter(name => !expected.includes(name));

    if (missing.length > 0) {
        console.warn(
            "[phase3] src/generation/index.js is missing expected exports:",
            missing
        );
    }
    if (unexpected.length > 0) {
        console.info(
            "[phase3] src/generation/index.js exports keys not in GENERATION_INDEX_EXPECTED_EXPORTS:",
            unexpected
        );
    }
    if (expected.length > 0 && missing.length === 0) {
        console.info(
            "[phase3] src/generation/index.js loaded via Vite. exports:",
            actual.size
        );
    }

    if (typeof window.__swapToModuleGenerationFacade === "function"
        && typeof GenerationModule.createGenerationFacade === "function") {
        const swapped = window.__swapToModuleGenerationFacade(
            GenerationModule.createGenerationFacade
        );
        if (!swapped) {
            console.warn(
                "[phase3] preferredGenerationApi swap reported failure  EHTML mirror remains active"
            );
        }
        return;
    }
    console.warn(
        "[phase3] cannot swap preferredGenerationApi:",
        {
            hasSwapHelper: typeof window.__swapToModuleGenerationFacade === "function",
            hasModuleFactory: typeof GenerationModule.createGenerationFacade === "function"
        }
    );
}

function runPhase3ProjectIoSwap() {
    const expectedProjectKeys = window.__PROJECT_IO_FACADE_KEYS_EXPECTED || [];
    const actualProjectKeys = new Set(Object.keys(ProjectModule));
    const missingProjectKeys = expectedProjectKeys.filter(name => !actualProjectKeys.has(name));
    if (missingProjectKeys.length > 0) {
        console.warn(
            "[phase3] src/project/index.js is missing expected exports:",
            missingProjectKeys
        );
    }

    if (typeof window.__swapToModuleProjectFacade === "function"
        && typeof ProjectModule.createProjectIoFacade === "function") {
        const swappedProject = window.__swapToModuleProjectFacade(
            ProjectModule.createProjectIoFacade
        );
        if (!swappedProject) {
            console.warn(
                "[phase3] preferredProjectIo swap reported failure  EHTML mirror remains active"
            );
        }
        return;
    }
    console.warn(
        "[phase3] cannot swap preferredProjectIo:",
        {
            hasSwapHelper: typeof window.__swapToModuleProjectFacade === "function",
            hasModuleFactory: typeof ProjectModule.createProjectIoFacade === "function"
        }
    );
}

bindProjectsBootstrapRuntime({
    bindProjectsClient: window.__bindProjectsClient,
    locationHref: window.location.href,
    handleAuthChange: (session) => {
        if (typeof window.__handleCloudSessionChange === "function") {
            window.__handleCloudSessionChange(session);
        }
    },
    refreshCloudAuthUi: () => {
        if (typeof window.__refreshCloudAuthUi === "function") window.__refreshCloudAuthUi();
    },
    info: (...args) => console.info(...args),
    warn: (...args) => console.warn(...args)
});
runPhase3GenerationFacadeSwap();
runPhase3ProjectIoSwap();
loadAssistantWidth();
bindAssistantResize();

const skillsUi = createSkillsUiController({
    getRefs: () => getFrontendDomRefs(),
    getAccessToken: () => getClerkAccessToken(),
    getProject: () => state.project,
    getSkillListItems: () => document.querySelectorAll(".skill-item"),
    getSelectedSkillCheckboxes: () => document.querySelectorAll(".skill-checkbox"),
    createElement: document.createElement.bind(document),
    syncAssistantState: (savedSkillIds) => {
        if (typeof state.chat === "undefined") return;
        state.chat.skillCount = savedSkillIds.length;
        if (typeof buildAssistantSettingsSummary === "function") {
            const activeProfile = getActivePlcProfile();
            state.chat.settingsSummary = buildAssistantSettingsSummary({
                assistant: {
                    dialect: activeProfile.vendorTarget || state.chat.dialect,
                    dialectLabel: activeProfile.name || getDialectMeta(state.chat.dialect).label,
                    plcProfileId: activeProfile.id,
                    plcProfileName: activeProfile.name,
                    mode: state.chat.mode
                },
                flowContext: getPreferredGenerationApi().exportFlowContext(),
                generationIr: getPreferredGenerationApi().exportGenerationIr(),
                project: state.project
            });
        }
        notifyAssistantUiChanged();
    },
    setTimeoutFn: (fn, delay) => setTimeout(fn, delay),
    error: (...args) => console.error(...args)
});

window.loadAndRenderSkills = skillsUi.loadAndRenderSkills;
window.initializeSkillsUi = skillsUi.initializeSkillsUi;
skillsUi.initializeSkillsUi();
